import { Box, Button, Collapse, Flex, HStack, Stack } from "@chakra-ui/react";
import Icon from "@modules/Icon";
import SearchBar from "@modules/Search/component/SearchBar";
import useSearchBar from "@modules/Search/hooks/useSearchBar";
import { Link as GatsbyLink } from "gatsby";
import React, { FC, memo } from "react";
import LinkSections from "../models/linkSection";
import { ISections } from "../models/type";
import { HomeLogoHero } from "../style";
import DropdownMenu from "./DropdownMenu";
import ResponsiveContainer from "./ResponsiveContainer";

interface IProps {}

const MainNavigation: FC<IProps> = () => {
  const { isShowSearch, handleSearchBar } = useSearchBar();

  return (
    <>
      <Box bg={"white"} borderBottom={"2px solid #F6F4EE"} py={4}>
        <ResponsiveContainer px={4}>
          <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
            <Box mt={-12}>
              <HomeLogoHero to="/" aria-label="home">
                <Icon name="logo" />
              </HomeLogoHero>
            </Box>

            <Flex alignItems={"center"}>
              <HStack>
                <Stack
                  direction={{ base: "column", md: "row" }}
                  width={{ base: "full", md: "auto" }}
                  alignItems="center"
                  flexGrow={1}
                >
                  {Object.keys(LinkSections).map((sectionKey, index) => {
                    const section = LinkSections[sectionKey as keyof ISections];

                    return <DropdownMenu key={index} section={section} />;
                  })}
                  <Box>
                    <Button variant="link" onClick={handleSearchBar}>
                      <Icon name="search" />
                    </Button>
                  </Box>
                </Stack>

                <Stack display={{ customLg: "flex", base: "none" }}>
                  <GatsbyLink to="/request-a-demo">
                    <Button variant="primary">Request a Demo</Button>
                  </GatsbyLink>
                </Stack>
              </HStack>
            </Flex>
          </Flex>
        </ResponsiveContainer>
      </Box>
      <Collapse in={isShowSearch} animateOpacity>
        <Box height={isShowSearch ? "auto" : 0}>
          <SearchBar />
        </Box>
      </Collapse>
    </>
  );
};

export default memo(MainNavigation);
